import { useMemo } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import type { GranularityLevel } from '../../api/types.js';

export const useLocalizedGranularityLevelLabels = () => {
  const { t } = useTranslation('@myn/import-hub');

  // Memoized so callers can use the result as a dependency: the import-hub
  // tables feed it into `columnDefs`, and a fresh object per render would make
  // those column definitions churn on every render.
  const granularityLevelLabelByType: Record<GranularityLevel, string> = useMemo(
    () =>
      ({
        platform: t('Platform'),
        media_row: t('Media row'),
        pricing_item: t('Placement folder ID'),
        platform_campaign: t('Placement folder ID / Campaign ID'),
      }) as const,
    [t],
  );

  return granularityLevelLabelByType;
};
